export const openThanksPage = (language: string, url?: string) => {
  const link = document.createElement("a");
  link.href = url ? url : `/${language}/thanks`;
  link.target = "_blank";
  link.click();
  link.remove();
};
